module.exports = __webpack_public_path__ + "static/media/8.84e66803.png";